export default __webpack_public_path__ + "static/media/about3.d8bacaa4.jpg";